import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { propsToDom } from 'core/helpers';
import { ContainerGrid } from 'components/Container';
import { Panel } from 'components/Panel';
import media from 'styles/media';

const VimeoComponent = ({ primary, items, slice_type, next_slice_type, ...others }) => {
  const { vimeo_url, background } = primary;

  return (
    <Panel {...propsToDom(others)} id={slice_type} nextId={next_slice_type} background={background}>
      <ContainerGrid>
        <Responsive dangerouslySetInnerHTML={{ __html: vimeo_url.html }} />
      </ContainerGrid>
    </Panel>
  );
};

const Responsive = styled.div`
  position: relative;
  grid-column: 2 / span 6;

  ${media.mobile`
    grid-column: 1 / -1;
  `}

  &:before {
    content: '';
    display: block;
    padding-bottom: ${(9 / 16) * 100}%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const Vimeo = styled(VimeoComponent)``;

export const query = graphql`
  fragment SliceVimeoHome on PrismicHomeDataBodyVimeo {
    id
    slice_type
    primary {
      background
      vimeo_url {
        html
      }
    }
  }

  fragment SliceVimeoPage on PrismicPageDataBodyVimeo {
    id
    slice_type
    primary {
      background
      vimeo_url {
        html
      }
    }
  }
`;
